<div class="rmpWrapper">
  <div class="rmpVideoContainer">
    <div id="rmpPlayer" #playerElement>&nbsp;</div>
  </div>

  <ng-container *ngIf="media">
    <h2 class="rmpVideoTitle">{{media.contentTitle}}</h2>
    <div class="rmpVideoDescription" [innerHTML]="media.contentDescription"></div>
  </ng-container>
</div>

<div #scriptElement></div>
